import type { IconProps } from "@/types/IconProps";

export function X(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m3.676 6.207-3.233 3.702-2.79-3.701H5.607l4.833 6.334-4.58 5.251H7.82l3.534-4.05 3.092 4.05h3.946l-5.04-6.679 4.283-4.907zM9.06 7.322l7.012 9.295h-1.086L7.895 7.322z"></path>
    </svg>
  );
}
